module.exports = __webpack_public_path__ + "media/show-nav.b47230c0.mp4";